<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="section-5">
<h1>6</h1>
<p>Monday morning. I’ve been with the Psalms of the <em>Tanakh</em>. I’m boiling a duck egg, toasting a slice of sourdough wholemeal bread, making a litre of coffee.</p>
<p>As I eat, I meditate on the words:</p><br/>
<p><em>But you, Adonai, are a shield for me; you are my glory, you lift my head high. With my voice I call out to Adonai, and he answers me from His holy hill. I lie down and sleep, then wake up again, because Adonai sustains me.</em></p><br/>
<p>My fast broken, I wash dishes, leave everything clean and neat in the kitchen, then phone Ollie Black. He picks up on the third ring and says:</p>
<p>“Called to thank me for putting gainful employment your way?”</p>
<p>“You were ridding yourself of a persistent widow.”</p>
<p>“Persistent she was.”</p>
<p>“Another fine mess I’ve gotten you out of, Ollie.”</p>
<p>“Don’t tell me: You want my help.”</p>
<p>“On a part-time basis.”</p>
<p>“Can the widow afford us?”</p>
<p>“She can.”</p>
<p>“Concession rates for the elderly.”</p>
<p>“Mary wants to forgive the men who killed her son.”</p>
<p>“Not easy to do.”</p>
<p>“Not if it’s done right.”</p>
<p>“You ever forgive somebody?”</p>
<p>“Yes.”</p>
<p>“A friend?”</p>
<p>“Yes.”</p>
<p>“What did he do to you?”</p>
<p>“Won’t say.”</p>
<p>“Do you still see him?”</p>
<p>“I do.”</p>
<p>“Ever cast it up to him?”</p>
<p>“Wouldn’t be right to.”</p>
<p>“Still think about it?”</p>
<p>“I don’t dwell on it.”</p>
<p>“Still friends?”</p>
<p>“With reservations.”</p>
<p>“Think it’ll be like that with the widow?”</p>
<p>“Best, if it is.”</p>
<p>“You’ll be wantin’ my case files on the abduction of Steven Ford.”</p>
<p>“How’d you guess?”</p>
<p>“It’s anorexic. The paper it’s written on is fatter.”</p>
<p>“No witnesses other than Mary?”</p>
<p>“Everybody watchin’ TV. Nobody stuck their noses out to see. Van was found burned out at the Bog Meadows. Main suspects: NIFF, crooks. Alibis galore, Capone would’ve been proud of them.”</p>
<p>“You got nowhere.”</p>
<p>“Got bogged down in the Meadows. No forensics. Slug from Mrs Ford’s leg was a .22. No matching gun. The case of the widow’s son was put on the back burner, then the gas was turned off.”</p>
<p>“Who turned it off?”</p>
<p>“The Chief Constable.”</p>
<p>“Desmond Hall.”</p>
<p>“The same. Took me off the case. Excuse was, trouble at Drumcree, first with Orangemen, then with Nationalists.”</p>
<p>“Anybody since looked into Steven’s abduction.”</p>
<p>“Priority wise it’s the lowest of the low.”</p>
<p>“Who’s leading the NIFF now?”</p>
<p>“Sammy Payne.”</p>
<p>“Was he in charge when Steven’s father died?”</p>
<p>“No, Jimmy Maynes was. Think there’s connection between the deaths of Steven and his father?”</p>
<p>“Wouldn’t rule it out. I’ll need to talk with Maynes.”</p>
<p>“He’s dead. Regime change.”</p>
<p>“Sammy Payne?”</p>
<p>“Little Caesar. Carries on like Edward G. Maynes’ daughter has sworn vengence and he’s gone into hiding.”</p>
<p>“Who investigated Patrick Ford’s death?”</p>
<p>“Desmond Hall. Inspector, then.”</p>
<p>“Find out for me how he handled it?”</p>
<p>“I’ll let you know.”</p>
<p>“Oh! One last thing. What about the girl? Did you find out who she was?”</p>
<p>“What girl?”</p>
<p>“The girl Mary says Steven took to the cinema a few times.”</p>
<p>“Never knew anything about a girl.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch010.vue?fa2b2dea